import { render, staticRenderFns } from "./data_all.vue?vue&type=template&id=540abd2b&scoped=true&"
import script from "./data_all.vue?vue&type=script&lang=js&"
export * from "./data_all.vue?vue&type=script&lang=js&"
import style0 from "./data_all.vue?vue&type=style&index=0&id=540abd2b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540abd2b",
  null
  
)

export default component.exports